var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 11 9",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.755 4.616a.74.74 0 01.227-.524L4.623.452a.736.736 0 01.797-.16.725.725 0 01.432.683v2.184h4.369c.41 0 .728.319.728.728v1.457a.733.733 0 01-.728.728H5.852v2.184c0 .274-.16.547-.432.66a.736.736 0 01-.797-.159l-3.64-3.64a.73.73 0 01-.228-.501z"
  })));
}
export default SvgArrowLeft;